export default __webpack_public_path__ + "static/media/palodentv3.724d5dfd.png";